import { MultiplierAnimationConfig } from '@Animation/types'
import { preLoadAssets } from './asset-preloader'
import { MichiganWheelMultiplierAnimation } from './mi-wheel-multiplier-animiation'

export const MI_MULTIPLIER_WHEEL_CONFIG: MultiplierAnimationConfig = {
  assetPreloader: preLoadAssets,
  revealAnimation: MichiganWheelMultiplierAnimation,
}
